import { TableCell, TableHead, TableRow } from '@one-thd/sui-atomic-components';
import React from 'react';
import { ITableHeaderData } from '../../../models/purchase-history/table';
import { ODTableHeaderData } from './ODTableHeaderData';

// 🚨 Will fix after merge
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ODTableHeader = ({ tableHeaderState }: any) => {
  const tableHeaderData = ODTableHeaderData(tableHeaderState);

  const emptyHeaders: ITableHeaderData[] = [];

  return (
    <TableHead>
      <TableRow>
        <>
          <TableCell style={{ width: '65px' }}>&nbsp;</TableCell>
          {tableHeaderData?.map((header: ITableHeaderData, index: number) => {
            if (header?.showHeader === false) {
              emptyHeaders.push(header);
              return null;
            }
            return (
              <TableCell
                key={index}
                align="left"
                variant="head"
                padding="none"
                style={header?.style}
              >
                {header?.title}
              </TableCell>
            );
          })}
          {emptyHeaders?.map((header, key) => {
            return (
              <TableCell
                key={key}
                align="left"
                variant="head"
                padding="none"
                style={(header as ITableHeaderData)?.style}
              >
                <div />
              </TableCell>
            );
          })}
          <TableCell style={{ width: '50px' }}>&nbsp;</TableCell>
        </>
      </TableRow>
    </TableHead>
  );
};
